import { render, staticRenderFns } from "./PurchasingDetail.vue?vue&type=template&id=38bc4ed7"
import script from "./PurchasingDetail.vue?vue&type=script&lang=js"
export * from "./PurchasingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports